import React, { ReactElement, useEffect, useState } from 'react';
import { formatBigNumber } from '../../../../common/utils/utils';
import { useGetDepositHistoryMutation } from '../../../../services/api/apiProvider';
import { DepositHistory } from '../../../../services/api/models/response/responseDepositHistory';
import './WalletTables.scss';

export const WalletAcquisition = (): ReactElement => {
  const [acquisition, setAcquisition] = useState<DepositHistory[]>([]);
  const [getDepositHistory] = useGetDepositHistoryMutation();

  useEffect(() => {
    getDepositHistory()
      .unwrap()
      .then((response) => {
        setAcquisition(response);
      });
  }, []);

  return (
    <table className="wallet-table">
      <thead>
        <tr>
          <th>購入日</th>
          <th>購入方法</th>
          <th>獲得数</th>
        </tr>
      </thead>
      <tbody>
        {acquisition.map(({ dateTime, description, coin }, idx) => (
          <tr key={idx}>
            <td>
              <span>{new Date(dateTime).toLocaleDateString('ja-JP')}</span>
            </td>
            <td>
              <span>{description}</span>
            </td>
            <td>
              <span>{formatBigNumber(coin)}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
